const makeEventUrl = (item) => {
	const baseUrl = process.env.baseFrontendURL;
	return `${baseUrl}${item.typology_slug}/${item.slug}/`;
};

const jsonldForItemList = (items) => {
	if (!items.data) {
		return {};
	}

	// Основные данные разметки
	const jsonldData = {
		'@context': 'http://schema.org',
		'@type': 'ItemList',
		itemListElement: items.data.map((item, index) => ({
			type: 'ListItem',
			position: index + 1,
			name: item.title,
			url: makeEventUrl(item),
		})),
	};

	return jsonldData;
};

export default jsonldForItemList;
